var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",on:{"click":_vm.handleClickEvent}},[(_vm.title)?_c('div',{staticClass:"card-header"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',_vm._b({staticClass:"card-body"},'div',_vm.cardBodyProps,false),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }